



<div class="margin" *ngIf="systemType>0">
  <panel heading="{{systemTitle | translate | async}}">
    <div class="system-overview">
    

          <img style="width: 20%;" *ngIf="!FamilyImage_Chain && systemType==1" src="/Content/Images/chain.jpg" >
          <img style="width: 20%;" *ngIf="FamilyImage_Chain && systemType==1" [src]="getImage_(FamilyImage_Chain)" >
          <img style="width: 20%;" *ngIf="!FamilyImage_Frame && systemType!==1" src="/Content/Images/frame.jpg"  >
          <img style="width: 20%;"*ngIf="FamilyImage_Frame && systemType!==1" [src]="getImage_(FamilyImage_Frame)" >



      <div class="system-overview__content">
        <div class="content__primary" >
          <div style="display: flex;flex-direction: column;"> 
            <div>
              <label class="top_label"> {{ "Serial Number" | translate | async }}</label>
            </div>
            <div>
              <label class="serial_label">{{SerialNo}}</label>
            </div>
          </div>
          

          <div *ngIf="systemType==1" style="display: flex;flex-direction: column;">
            <div>
              <label class="top_label"> {{ "CMU" | translate | async }}</label>
            </div>
            <div>
              <label >{{chain_CMU}}</label>
            </div>
          </div>
  
          <div *ngIf="systemType==1 && side==1">
            <div>
              <label class="top_label"> {{ "Track Sag (mm)" | translate | async }}</label>
            </div>
            <div>
              <input class="input-travel inspectionSMUInput" type="number" [(ngModel)]="tracksag_L" (focusout)="UpdateTrackSag(1)" /> 
            </div>
          </div>

          <div *ngIf="systemType==1 && side==2">
            <div>
              <label class="top_label"> {{ "Track Sag (mm)" | translate | async }}</label>
            </div>
            <div>
              <input class="input-travel inspectionSMUInput" type="number" [(ngModel)]="tracksag_R" (focusout)="UpdateTrackSag(2)" /> 
            </div>
          </div>
        </div>
    
        
      </div>
    </div>
    

    <div class="table-container" *ngIf="FrameSystem_L !=null &&  systemType==2 && side==1">
      <table class="table table--full-width table--striped">
        <thead>
          <tr>
            <th></th>
            <th>{{'Component' | translate | async}}</th>
            <th>{{'Position' | translate | async}}</th>
            <th class="textCenter">{{'Severity' | translate | async}}</th>
            <th>{{'CMU' | translate | async}} </th>
            <th class="right-align"><div class="textCenter">{{'Photo' | translate | async}}</div></th>
            <th class="right-align"><div class="textCenter">{{'Comment' | translate | async}} </div></th>
            <th class="right-align"><div class="textCenter">{{'Document' | translate | async}} </div></th>

          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of FrameSystem_L">
            <td class="component-cell">
              <div class="component-photo-container">
                <img class="component-photo" [src]="getImage_(c.CompImage)" />
              </div>
            </td>
            
            <td class="namecell">
              <span title="{{c.ComponentName}}">{{c.ComponentName | slice:0:35}} {{c.ComponentName.length>35 ? '...' : ''}} </span>
          
            </td>
            <!-- <td>{{c.Position}}</td> -->
            <td> {{showPosition(c.Position, c.CompartTypeId)}}</td>
            <td class="table__eval-cell">
                      <mat-select [(value)]="c.Eval"  class="tool-button  eval eval--{{c.Eval}}" title="{{'Change Component Eval' | translate | async}}" 
                      (selectionChange)="changeEval(c.DetailId,$event)">
                      <mat-option value="M">M</mat-option>
                      <mat-option value="A">A</mat-option>
                      <mat-option value="B">B</mat-option>
                      <mat-option value="C">C</mat-option>
                      <mat-option value="X">X</mat-option>
                      <mat-option value="MR">MR</mat-option>
                      </mat-select>
          
            </td>
            <td class="inspection-component-photo">
             {{ c.CMU }}
            </td>
            <td  class="textCenter">
              <upload-photo *ngIf="c.Image == ''" (onPhotoUpload)="LoadInspectionDetails(1,2)" [inspectionDetailId]="c.DetailId" [isThermoInspectionDetail]=true></upload-photo>
              <!-- <img style="width: 35px;" (click)="viewInspectionDetailPhoto(c.DetailId,c.Image,true,1,2)" class="inspection-component-photo__photo" [src]="getImage_(c.Image)" *ngIf="c.Image !=''" /> -->
              <i  *ngIf="c.Image !=''"  class="material-icons upload-container__icon" style ="border: 1px solid #ed5565;color: #ed5565; padding: 8px;"  (click)="viewInspectionDetailPhoto(c.DetailId,c.Image,true,1,2)">
                add_a_photo
              </i>
            </td>
            <td  class="textCenter componentComment">
             <!-- {{c.Comment | slice:0:30}} {{c.Comment?.length>30 ? '...' : ''}} -->
              <div class="add-recommendation" id="c.DetailId" [class.has-recommendation]="c.Comment !=='' && c.Comment!== null" > 
                <i title="Add/View Comment" class="material-icons" (click)="AddComment(c.DetailId,c.Comment,true,1,2)">message</i>
              </div>
            </td>
            <td class="textCenter componentComment">
              <i *ngIf="c.FilePreview!=''"  class="material-icons upload-container__icon" style ="border: 1px solid #ed5565;color: #ed5565; padding: 8px;" 
              (click)="onClickDownloadForm(c)" title="View Document">picture_as_pdf</i>
               <i  class="material-icons add-doc" title="Add Document" (click)="openAttachDoc(c,1,2)">add</i>     
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="table-container" *ngIf="FrameSystem_R !=null &&  systemType==2 && side==2">
      <table class="table table--full-width table--striped">
        <thead>
          <tr>
            <th></th>
            <th>{{'Component' | translate | async}}</th>
            <th>{{'Position' | translate | async}}</th>
            <th class="textCenter">{{'Severity' | translate | async}}</th>
            <th>{{'CMU' | translate | async}} </th>
            <th class="right-align"><div class="textCenter">{{'Photo' | translate | async}}</div></th>
            <th class="right-align"><div class="textCenter">{{'Comment' | translate | async}} </div></th>
            <th class="right-align"><div class="textCenter">{{'Document' | translate | async}} </div></th>

          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of FrameSystem_R">
            <td class="component-cell">
              <div class="component-photo-container">
                <img class="component-photo" [src]="getImage_(c.CompImage)" />
              </div>
            </td>
            
            <td class="namecell">
              <span title="{{c.ComponentName}}">{{c.ComponentName | slice:0:35}} {{c.ComponentName.length>35 ? '...' : ''}} </span>
          
            </td>
            <!-- <td>{{c.Position}}</td> -->
            <td> {{showPosition(c.Position, c.CompartTypeId)}}</td>
            <td class="table__eval-cell">
             
      

                      <mat-select [(value)]="c.Eval"  class="tool-button  eval eval--{{c.Eval}}" title="{{'Change Component Eval' | translate | async}}" 
                      (selectionChange)="changeEval(c.DetailId,$event)">
                      <mat-option value="M">M</mat-option>
                      <mat-option value="A">A</mat-option>
                      <mat-option value="B">B</mat-option>
                      <mat-option value="C">C</mat-option>
                      <mat-option value="X">X</mat-option>
                      <mat-option value="MR">MR</mat-option>
                      </mat-select>
          
            </td>
            <td class="inspection-component-photo">
             {{ c.CMU }}
            </td>
            <td  class="textCenter">
              <upload-photo *ngIf="c.Image == ''" (onPhotoUpload)="LoadInspectionDetails(2,2)" [inspectionDetailId]="c.DetailId" [isThermoInspectionDetail]=true></upload-photo>
              <!-- <img style="width: 35px;" (click)="viewInspectionDetailPhoto(c.DetailId,c.Image,true,2,2)" class="inspection-component-photo__photo" [src]="getImage_(c.Image)" *ngIf="c.Image !=''" /> -->
              <i  *ngIf="c.Image !=''"  class="material-icons upload-container__icon" style ="border: 1px solid #ed5565;color: #ed5565; padding: 8px;"  (click)="viewInspectionDetailPhoto(c.DetailId,c.Image,true,2,2)" >
                add_a_photo
              </i>
            </td>
            <td  class="textCenter componentComment">
             <!-- {{c.Comment | slice:0:30}} {{c.Comment?.length>30 ? '...' : ''}} -->
              <div class="add-recommendation" id="c.DetailId" [class.has-recommendation]="c.Comment !=='' && c.Comment!== null" > 
                <i title="Add/View Comment" class="material-icons" (click)="AddComment(c.DetailId,c.Comment,true,2,2)">message</i>
              </div>

              
            </td>
            <td class="textCenter componentComment">
              <i *ngIf="c.FilePreview!=''"  class="material-icons upload-container__icon" style ="border: 1px solid #ed5565;color: #ed5565; padding: 8px;" 
              (click)="onClickDownloadForm(c)" title="View Document">picture_as_pdf</i>
               <i  class="material-icons add-doc" title="Add Document" (click)="openAttachDoc(c,1,2)">add</i>     
            </td>
          </tr>
        </tbody>
      </table>
    </div>



    <div class="table-container" *ngIf="systemType==1 && ChainSystem_L != null && side==1">
      <table class="table table--full-width table--striped">
        <thead>
          <tr>
            <th></th>
            <th>{{'Pin Number' | translate | async}}</th>
            <th class="textCenter">{{'Severity' | translate | async}}</th>
            <th class="right-align"><div class="textCenter">{{'Photo' | translate | async}}</div></th>
            <th class="right-align"><div class="textCenter">{{'Comment' | translate | async}} </div></th>
            <th class="right-align"><div class="textCenter">{{'Document' | translate | async}} </div></th>

          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of ChainSystem_L"  >
            <td class="component-cell">
              <div class="component-photo-container">
                <img class="component-photo"  src="/Content/Images/link.png" />
              </div>
            </td>
            
            <td class="namecell">
              <span title="{{c.ComponentName}}">{{c.ComponentName | slice:0:35}} {{c.ComponentName.length>35 ? '...' : ''}} </span>
          
            </td>
           
            <td class="table__eval-cell">
              <mat-select [(value)]="c.Eval"  class="tool-button  eval eval--{{c.Eval}}" title="{{'Change Component Eval' | translate | async}}" 
                      (selectionChange)="changeEval(c.DetailId,$event)">
                      <mat-option value="M">M</mat-option>
                      <mat-option value="A">A</mat-option>
                      <mat-option value="B">B</mat-option>
                      <mat-option value="C">C</mat-option>
                      <mat-option value="X">X</mat-option>
                      <mat-option value="MR">MR</mat-option>

                      </mat-select>
            </td>
            <td  class="textCenter">
              <upload-photo *ngIf="c.Image == ''" (onPhotoUpload)="LoadInspectionDetails(1,1)" [inspectionDetailId]="c.DetailId" [isThermoInspectionDetail]=true></upload-photo>
              <!-- <img style="width: 35px;" (click)="viewInspectionDetailPhoto(c.DetailId,c.Image,true,1,1)" class="inspection-component-photo__photo" [src]="getImage_(c.Image)" *ngIf="c.Image !=''" /> -->
              <i  *ngIf="c.Image !=''"  class="material-icons upload-container__icon" style ="border: 1px solid #ed5565;color: #ed5565; padding: 8px;"  (click)="viewInspectionDetailPhoto(c.DetailId,c.Image,true,1,1)">
                add_a_photo
              </i>
          </td>
            <td  class="textCenter componentComment">
              <div class="add-recommendation" id="c.DetailId" [class.has-recommendation]="c.Comment !=='' && c.Comment!== null" > 
                <i title="Add/View Comment" class="material-icons" (click)="AddComment(c.DetailId,c.Comment,true,1,1)">message</i>
              </div>
            </td>
            <td class="textCenter componentComment">
              <i *ngIf="c.FilePreview!=''"  class="material-icons upload-container__icon" style ="border: 1px solid #ed5565;color: #ed5565; padding: 8px;" 
              (click)="onClickDownloadForm(c)" title="View Document">picture_as_pdf</i>
               <i  class="material-icons add-doc" title="Add Document" (click)="openAttachDoc(c,1,2)">add</i>     
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="table-container" *ngIf="systemType==1 && ChainSystem_R != null && side==2">
      <table class="table table--full-width table--striped">
        <thead>
          <tr>
            <th></th>
            <th>{{'Pin Number' | translate | async}}</th>
            <th class="textCenter">{{'Severity' | translate | async}}</th>
            <th class="right-align"><div class="textCenter">{{'Photo' | translate | async}}</div></th>
            <th class="right-align"><div class="textCenter">{{'Comment' | translate | async}} </div></th>
            <th class="right-align"><div class="textCenter">{{'Document' | translate | async}} </div></th>

          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of ChainSystem_R"  >
            <td class="component-cell">
              <div class="component-photo-container">
                <img class="component-photo"  src="/Content/Images/link.png" />
              </div>
            </td>
            
            <td class="namecell">
              <span title="{{c.ComponentName}}">{{c.ComponentName | slice:0:35}} {{c.ComponentName.length>35 ? '...' : ''}} </span>
          
            </td>
           
            <td class="table__eval-cell">
              <mat-select [(value)]="c.Eval"  class="tool-button  eval eval--{{c.Eval}}" title="{{'Change Component Eval' | translate | async}}" 
                      (selectionChange)="changeEval(c.DetailId,$event)">
                      <mat-option value="M">M</mat-option>
                      <mat-option value="A">A</mat-option>
                      <mat-option value="B">B</mat-option>
                      <mat-option value="C">C</mat-option>
                      <mat-option value="X">X</mat-option>
                      <mat-option value="MR">MR</mat-option>

                      </mat-select>
            </td>
            <td  class="textCenter">
              <upload-photo *ngIf="c.Image == ''" (onPhotoUpload)="LoadInspectionDetails(2,1)" [inspectionDetailId]="c.DetailId" [isThermoInspectionDetail]=true></upload-photo>
              <!-- <img style="width: 35px;" (click)="viewInspectionDetailPhoto(c.DetailId,c.Image,true,2,1)" class="inspection-component-photo__photo" [src]="getImage_(c.Image)" *ngIf="c.Image !=''" /> -->
              <i  *ngIf="c.Image !=''"  class="material-icons upload-container__icon" style ="border: 1px solid #ed5565;color: #ed5565; padding: 8px;" (click)="viewInspectionDetailPhoto(c.DetailId,c.Image,true,2,1)">
                add_a_photo
              </i>
          </td>
            <td  class="textCenter componentComment">
              <div class="add-recommendation" id="c.DetailId" [class.has-recommendation]="c.Comment !=='' && c.Comment!== null" > 
                <i title="Add/View Comment" class="material-icons" (click)="AddComment(c.DetailId,c.Comment,true,2,1)">message</i>
              </div>
            </td>
            <td class="textCenter componentComment">
              <i *ngIf="c.FilePreview!=''"  class="material-icons upload-container__icon" style ="border: 1px solid #ed5565;color: #ed5565; padding: 8px;" 
              (click)="onClickDownloadForm(c)" title="View Document">picture_as_pdf</i>
               <i  class="material-icons add-doc" title="Add Document" (click)="openAttachDoc(c,1,2)">add</i>     
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </panel>
</div>

<div class="margin" *ngIf="systemType==0">
  <panel heading="{{systemTitle | translate | async}}">
    <div class="system-overview">
    

          <img style="width: 20%;" src="/Content/Images/NO-IMAGE.png" >

    </div>
    

    <div class="table-container" *ngIf="AdditionalSys_L !=null && side==1">
      <table class="table table--full-width table--striped">
        <thead>
          <tr>
            <th></th>
            <th>{{'Component' | translate | async}}</th>
            <th class="textCenter">{{'Severity' | translate | async}}</th>
            <th class="right-align"><div class="textCenter">{{'Photo' | translate | async}}</div></th>
            <th class="right-align"><div class="textCenter">{{'Comment' | translate | async}} </div></th>
            <th class="right-align"><div class="textCenter">{{'Document' | translate | async}} </div></th>

          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of AdditionalSys_L">
            <td class="component-cell">
              <div class="component-photo-container">
                <img class="component-photo" [src]="getImage_(c.CompImage)" />
              </div>
            </td>
            
            <td class="namecell" style="width: 150px;">
              <span title="{{c.ComponentName}}">{{c.ComponentName | slice:0:35}} {{c.ComponentName.length>35 ? '...' : ''}} </span>
          
            </td>
           
            <td class="table__eval-cell">
             
              <!-- <select [(ngModel)]="c.Eval">        
                <option [value]="0">0</option>
                <option [value]="1">1</option>
                <option [value]="2">2</option>
                <option [value]="3">3</option>
                <option [value]="4">4</option>
           </select> -->

           <mat-select [(value)]="c.Eval"  class="tool-button  eval eval--{{c.Eval}}" title="{{'Change Component Eval' | translate | async}}" 
           (selectionChange)="changeEval(c.DetailId,$event)" disableOptionCentering panelClass="myPanelClass">
             <mat-option value="M">M</mat-option>
             <mat-option value="A">A</mat-option>
             <mat-option value="B">B</mat-option>
             <mat-option value="C">C</mat-option>
             <mat-option value="X">X</mat-option>
             <mat-option value="MR">MR</mat-option>

           </mat-select>
          
            </td>
            <td  class="textCenter">
              <!-- <upload-photo *ngIf="c.Image == '' "   (onPhotoUpload)="reloadSystem()" ></upload-photo>
              <img (click)="viewComponentPhoto(c.TempOneImageOnly, c)" class="inspection-component-photo__photo" [src]="getImage_(c.Image)" *ngIf="c.Image != ''" /> -->

              <upload-photo *ngIf="c.Image == ''" (onPhotoUpload)="LoadInspectionDetails(1,0)" [inspectionDetailId]="c.DetailId" [isThermoInspectionDetail]=true></upload-photo>
              <!-- <img style="width: 35px;" (click)="viewInspectionDetailPhoto(c.DetailId,c.Image,true,1,0)" class="inspection-component-photo__photo" [src]="getImage_(c.Image)" *ngIf="c.Image !=''" /> -->
           
              <i  *ngIf="c.Image !=''"  class="material-icons upload-container__icon" style ="border: 1px solid #ed5565;color: #ed5565; padding: 8px;" (click)="viewInspectionDetailPhoto(c.DetailId,c.Image,true,1,0)">
                add_a_photo
              </i>
            </td>
            <td  class="textCenter componentComment">
              <div class="add-recommendation" id="c.DetailId" [class.has-recommendation]="c.Comment !=='' && c.Comment!== null" > 
                <i title="Add/View Comment" class="material-icons" (click)="AddComment(c.DetailId,c.Comment,true,1,0)">message</i>
              </div>
            </td>
            <td class="textCenter componentComment">
              <i *ngIf="c.FilePreview!=''"  class="material-icons upload-container__icon" style ="border: 1px solid #ed5565;color: #ed5565; padding: 8px;" 
              (click)="onClickDownloadForm(c)" title="View Document">picture_as_pdf</i>
               <i  class="material-icons add-doc" title="Add Document" (click)="openAttachDoc(c,1,2)">add</i>     
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="table-container"  *ngIf="AdditionalSys_N !=null && side==0">
      <table class="table table--full-width table--striped">
        <thead>
          <tr>
            <th></th>
            <th>{{'Component' | translate | async}}</th>
            <th class="textCenter">{{'Severity' | translate | async}}</th>
            <th class="right-align"><div class="textCenter">{{'Photo' | translate | async}}</div></th>
            <th class="right-align"><div class="textCenter">{{'Comment' | translate | async}} </div></th>
            <th class="right-align"><div class="textCenter">{{'Document' | translate | async}} </div></th>

          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of AdditionalSys_N">
            <td class="component-cell">
              <div class="component-photo-container">
                <img class="component-photo" [src]="getImage_(c.CompImage)" />
              </div>
            </td>
            
            <td class="namecell" style="width: 150px;">
              <span title="{{c.ComponentName}}">{{c.ComponentName | slice:0:35}} {{c.ComponentName.length>35 ? '...' : ''}} </span>
          
            </td>
           
            <td class="table__eval-cell">
             
              <!-- <select [(ngModel)]="c.Eval">        
                <option [value]="0">0</option>
                <option [value]="1">1</option>
                <option [value]="2">2</option>
                <option [value]="3">3</option>
                <option [value]="4">4</option>
           </select> -->

           <mat-select [(value)]="c.Eval"  class="tool-button  eval eval--{{c.Eval}}" title="{{'Change Component Eval' | translate | async}}" 
           (selectionChange)="changeEval(c.DetailId,$event)" disableOptionCentering panelClass="myPanelClass">
             <mat-option value="M">M</mat-option>
             <mat-option value="A">A</mat-option>
             <mat-option value="B">B</mat-option>
             <mat-option value="C">C</mat-option>
             <mat-option value="X">X</mat-option>
             <mat-option value="MR">MR</mat-option>

           </mat-select>
          
            </td>
            <td  class="textCenter">
              <!-- <upload-photo *ngIf="c.Image == '' "   (onPhotoUpload)="reloadSystem()" ></upload-photo>
              <img (click)="viewComponentPhoto(c.TempOneImageOnly, c)" class="inspection-component-photo__photo" [src]="getImage_(c.Image)" *ngIf="c.Image != ''" /> -->

              <upload-photo *ngIf="c.Image == ''" (onPhotoUpload)="LoadInspectionDetails(0,0)" [inspectionDetailId]="c.DetailId" [isThermoInspectionDetail]=true></upload-photo>
              <!-- <img style="width: 35px;" (click)="viewInspectionDetailPhoto(c.DetailId,c.Image,true,0,0)" class="inspection-component-photo__photo" [src]="getImage_(c.Image)" *ngIf="c.Image !=''" /> -->
              <i  *ngIf="c.Image !=''"  class="material-icons upload-container__icon" style ="border: 1px solid #ed5565;color: #ed5565; padding: 8px;" (click)="viewInspectionDetailPhoto(c.DetailId,c.Image,true,0,0)">
                add_a_photo
              </i>
            </td>
            <td  class="textCenter componentComment">
              <div class="add-recommendation" id="c.DetailId" [class.has-recommendation]="c.Comment !=='' && c.Comment!== null" > 
                <i title="Add/View Comment" class="material-icons" (click)="AddComment(c.DetailId,c.Comment,true,0,0)">message</i>
              </div>
            </td>

            <td class="textCenter componentComment">
              <i *ngIf="c.FilePreview!=''"  class="material-icons upload-container__icon" style ="border: 1px solid #ed5565;color: #ed5565; padding: 8px;" 
              (click)="onClickDownloadForm(c)" title="View Document">picture_as_pdf</i>
               <i  class="material-icons add-doc" title="Add Document" (click)="openAttachDoc(c,1,2)">add</i>     
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="table-container" *ngIf="AdditionalSys_R !=null && side==2">
      <table class="table table--full-width table--striped">
        <thead>
          <tr>
            <th></th>
            <th>{{'Component' | translate | async}}</th>
            <th class="textCenter">{{'Severity' | translate | async}}</th>
            <th class="right-align"><div class="textCenter">{{'Photo' | translate | async}}</div></th>
            <th class="right-align"><div class="textCenter">{{'Comment' | translate | async}} </div></th>
            <th class="right-align"><div class="textCenter">{{'Document' | translate | async}} </div></th>

          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of AdditionalSys_R">
            <td class="component-cell">
              <div class="component-photo-container">
                <img class="component-photo" [src]="getImage_(c.CompImage)" />
              </div>
            </td>
            
            <td class="namecell" style="width: 150px;">
              <span title="{{c.ComponentName}}">{{c.ComponentName | slice:0:35}} {{c.ComponentName.length>35 ? '...' : ''}} </span>
          
            </td>
           
            <td class="table__eval-cell">
           <mat-select [(value)]="c.Eval"  class="tool-button  eval eval--{{c.Eval}}" title="{{'Change Component Eval' | translate | async}}" 
           (selectionChange)="changeEval(c.DetailId,$event)" disableOptionCentering panelClass="myPanelClass">
             <mat-option value="M">M</mat-option>
             <mat-option value="A">A</mat-option>
             <mat-option value="B">B</mat-option>
             <mat-option value="C">C</mat-option>
             <mat-option value="X">X</mat-option>
             <mat-option value="MR">MR</mat-option>

           </mat-select>
          
            </td>
            <td  class="textCenter">
              <!-- <upload-photo *ngIf="c.Image == '' "   (onPhotoUpload)="reloadSystem()" ></upload-photo>
              <img (click)="viewComponentPhoto(c.TempOneImageOnly, c)" class="inspection-component-photo__photo" [src]="getImage_(c.Image)" *ngIf="c.Image != ''" /> -->

              <upload-photo *ngIf="c.Image == ''" (onPhotoUpload)="LoadInspectionDetails(2,0)" [inspectionDetailId]="c.DetailId" [isThermoInspectionDetail]=true></upload-photo>
              <!-- <img style="width: 35px;" (click)="viewInspectionDetailPhoto(c.DetailId,c.Image,true,2,0)" class="inspection-component-photo__photo" [src]="getImage_(c.Image)" *ngIf="c.Image !=''" /> -->
           
              <i  *ngIf="c.Image !=''"  class="material-icons upload-container__icon" style ="border: 1px solid #ed5565;color: #ed5565; padding: 8px;" (click)="viewInspectionDetailPhoto(c.DetailId,c.Image,true,2,0)">
                add_a_photo
              </i>
            </td>
            <td  class="textCenter componentComment">
              <div class="add-recommendation" id="c.DetailId" [class.has-recommendation]="c.Comment !=='' && c.Comment!== null" > 
                <i title="Add/View Comment" class="material-icons" (click)="AddComment(c.DetailId,c.Comment,true,2,0)">message</i>
              </div>
            </td>

            <td class="textCenter componentComment">
              <i *ngIf="c.FilePreview!=''"  class="material-icons upload-container__icon" style ="cursor: pointer; border: 1px solid #ed5565;color: #ed5565; padding: 8px;" 
              (click)="onClickDownloadForm(c)" title="View Document">picture_as_pdf</i>
               <i  class="material-icons add-doc" title="Add/Replace Document" style="cursor: pointer;" (click)="openAttachDoc(c,1,2)">add</i>     
            </td>
          </tr>
        </tbody>
      </table>
    </div>


  </panel>
</div>
